import { Redirect } from 'expo-router';
import { useContext } from 'react';
import { View } from 'react-native';
import JobsContext from './context/JobsContext';
import { useThemePalette } from './theme';

export default function Index() {
  const { hydrated, onboardingCompleted } = useContext(JobsContext);
  const palette = useThemePalette();

  if (!hydrated) {
    return <View style={{ flex: 1, backgroundColor: palette.canvas }} />;
  }

  return <Redirect href={onboardingCompleted ? '/(tabs)' : '/onboarding'} />;
}
